import { APP_ROUTES } from '../contants/routes';

export const routeFileSelector = (path: string) => {
  let routeName = '';

  switch (path) {
    case APP_ROUTES.HOME:
      routeName = 'home';
      break;
    case APP_ROUTES.SHIPMENT:
    case APP_ROUTES.ADD_SHIPMENT:
    case APP_ROUTES.CREATE_SHIPMENT:
    case APP_ROUTES.CREATE_SHIPMENT_ID:
    case APP_ROUTES.SHIPMENT_GET_QUOTE:
    case APP_ROUTES.SHIPMENT_PARCEL_EXPRESS:
    case APP_ROUTES.SHIPMENT_NOTIFICATION_ROUTING:
      routeName = 'shipment';
      break;
    case APP_ROUTES.VISIBILITY:
      routeName = 'visibility';
      break;
    case APP_ROUTES.CLAIMS:
      routeName = 'claims';
      break;
    case APP_ROUTES.PROCUREMENT:
    case APP_ROUTES.ADD_PROJECT_PROCUREMENT:
    case APP_ROUTES.ADD_TENDER_PROCUREMENT:
    case APP_ROUTES.PROCUREMENT_PROJECT:
    case APP_ROUTES.PROCUREMENT_TENDER:
    case APP_ROUTES.PROCUREMENT_BID_ANALYSIS:
    case APP_ROUTES.PROCUREMENT_ROUTE_CONFIG:
    case APP_ROUTES.PROCUREMENT_ROUTE_CONFIG_LOCATION:
    case APP_ROUTES.ADD_ROUTING_GUIDE:
    case APP_ROUTES.ADD_NXP_USER:
    case APP_ROUTES.ADD_LANE:
      routeName = 'procurement';
      break;
    case APP_ROUTES.PURCHASE_ORDER_VIEW:
    case APP_ROUTES.PURCHASE_ORDER_MANAGEMENT:
    case APP_ROUTES.PURCHASE_ORDER_MANAGEMENT_ID:
    case APP_ROUTES.PURCHASE_ORDER_VENDOR_SEARCH:
    case APP_ROUTES.PURCHASE_ORDER_SHIPMENT_SEARCH:
    case APP_ROUTES.PURCHASE_ORDER_PRE_BOOKING_SEARCH:
    case APP_ROUTES.PURCHASE_ORDER_DRAFT_SEARCH:
      routeName = 'purchase';
      break;
    case APP_ROUTES.TMS_SETTINGS:
      routeName = 'tms-settings';
      break;
    case APP_ROUTES.AUCTION:
      routeName = 'auction';
      break;
    case APP_ROUTES.SETTINGS:
      routeName = 'settings';
      break;
    case APP_ROUTES.RATE_SHOP:
      routeName = 'rate-shop';
      break;
    case APP_ROUTES.CarrQuoteDashboard:
      routeName = 'CarrQuoteDashboard';
      break;
    case APP_ROUTES.SAVERS:
    case APP_ROUTES.SAVERS_HOME:
    case APP_ROUTES.SAVERS_SUPPLYZONE:
    case APP_ROUTES.SAVERS_LOCATIONS:
    case APP_ROUTES.SAVERS_TRAILERDATABASE:
      routeName = 'savers';
      break;
    default:
      routeName = 'translation';
  }

  return routeName;
};
